import http from './http'
//
/**
 *  @parms resquest 请求地址
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

const resquest = `/UserRole`
function getUserMenuPermission(params) {
  return http.get(`${resquest}/getUserMenuPermission`, params)
}

function getUserRolePages(params) {
  return http.post(`${resquest}/getUserRolePages`, params)
}
function addUserRole(params) {
  return http.post(`${resquest}/addUserRole`, params)
}

function getUserRoleAssignedPermission(params) {
  return http.get(`${resquest}/getUserRoleAssignedPermission`, params)
}
function getUserRoleUnassignedPermission(params) {
  return http.get(`${resquest}/getUserRoleUnassignedPermission`, params)
}
function grantPermission(params) {
  return http.post(`${resquest}/grantPermission`, params)
}

function disableUserRole(params) {
    return http.put(`${resquest}/disableUserRole`, params)
  }

function enableUserRole(params) {
  return http.put(`${resquest}/enableUserRole`, params)
}

const user = `/user`
function getUserPages(params) {
  return http.post(`${user}/getUserPages`, params)
}

const company = `/Company`
function getApplyRecordPageList(params) {
  return http.post(`${company}/getApplyRecordPageList`, params)
}
function passCompany(params) {
  return http.post(`${company}/passCompany`, params)
}
function operationCompany(params) {
  return http.post(`${company}/operationCompany`, params)
}
function refuseCompany(params) {
  return http.post(`${company}/refuseCompany`, params)
}

const SystemFile = `/SystemFile`
function uploadFile(params) {
  return http.upload(`/api/${SystemFile}/uploadFile`, params)
}
function previewFile(params) {
  return http.post(`${SystemFile}/previewFile`, params)
}
function downLoadFile(params) {
  return http.get(`${SystemFile}/downLoadFile`, params)
}
function deleteSystemFile(params) {
  return http.get(`${SystemFile}/deleteSystemFile`, params)
}
function getFileList(params) {
  return http.get(`${SystemFile}/getFileList`, params)
}

const Address = `/Address`
function getAddress(params) {
  return http.get(`${Address}/getAddress`, params)
}

const comm = `/Comm`
function getSysParams(params) {
    return http.get(`${comm}/getSysParams`, params)
}
function addParams(params) {
    return http.post(`${comm}/addParams`, params)
}
function updateParams(params) {
    return http.post(`${comm}/updateParams`, params)
}
function deleteParams(params) {
    return http.post(`${comm}/deleteParams`, params)
}

export {
  getUserMenuPermission,
  getUserPages,
  addUserRole,
  getUserRolePages,
  getUserRoleAssignedPermission,
  getUserRoleUnassignedPermission,
  grantPermission,
  disableUserRole,
  enableUserRole,
  getApplyRecordPageList,
  passCompany,
  operationCompany,
  refuseCompany,
  uploadFile,
  previewFile,
  getAddress,
  getSysParams,
  addParams,
  updateParams,
  deleteParams,
  downLoadFile,
  deleteSystemFile,
  getFileList
}
